var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#FFA04B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4189 29.8025C34.1171 28.4843 35.7957 25.7991 35.7957 22.7957C35.7957 20.747 34.9775 18.7956 33.4872 17.3085C31.9969 15.8182 30.0488 15 28 15C23.7011 15 20.2043 18.4969 20.2043 22.7957H24.1557C24.1557 20.6755 25.8798 18.9514 28 18.9514C28.9935 18.9514 29.9514 19.3605 30.6916 20.1041C31.4352 20.8476 31.8443 21.8022 31.8443 22.799C31.8443 24.2796 31.0163 25.6043 29.6851 26.2569C27.461 27.3381 26.0259 29.744 26.0259 32.3773V33.8059H29.9773V32.3773C29.9741 31.2409 30.5423 30.2311 31.4189 29.8025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.0647C26.6428 36.0647 25.5388 37.1719 25.5388 38.5258C25.5388 39.896 26.646 40.9999 28 40.9999C29.3572 40.9999 30.4611 39.8928 30.4611 38.5258C30.4611 37.1719 29.3572 36.0647 28 36.0647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.588dae46ac221d710c5ac3498c47a3dd.svg";
export { ForwardRef as ReactComponent };